<template>
  <b-container class="text-center">
    <b-row>
      <b-col>
        <img
          src="https://cdn.vexels.com/img/licenses-available.svg"
          :alt="$t('home.merch.header.licencesAlt')"
          class="w-100 h-auto"
          loading="lazy"
          width="700"
          height="80"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['slice']
};
</script>

<style lang="scss" scoped>
.text {
  font-weight: 500;
  font-size: 1.3em;
  color: $strongGray;
}
</style>
